import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  useSearchCreditorsByBallotIdQuery,
  useCreateCreditorVoteMutation,
  useGetVoterDeatilsQuery,
  useUpdateCreditorVoteMutation,
} from "./votingReducer";
import {
  MotifButton,
  MotifModal,
  MotifModalHeader,
  MotifModalBody,
  MotifModalFooter,
  MotifLabel,
  MotifInput,
  MotifFormField,
  MotifOption,
  MotifSelect,
  MotifErrorMessage,
  MotifProgressLoader,
} from "@ey-xd/motif-react";
import CreditorDetails from "@/pages/CaseDetail/Claim/claimSetup/Creditor/Components/CreditorDetails";
import {
  CANCEL_BUTTON_VARIANT,
  SAVE_BUTTON_VARIANT,
} from "@/components/Images/CommonImages";

interface RecordVoteProps {
  readBallot: any;
  showModal: boolean;
  setShowModal: any;
  voterId?: string;
  setErrorMsg?:any
}

const RecordVote = ({
  readBallot,
  showModal,
  setShowModal,
  voterId = "",
  setErrorMsg
}: RecordVoteProps) => {
  const { editId } = useParams<{
    editId: string;
  }>();
  const { t } = useTranslation();

  const [selectedCreditorDetail, setSelectedCreditorDetail] = useState<any>({});
  const [voteType, setVoteType] = useState("");
  const [proxy, setProxy] = useState("");

  const {
    data: creditorData,
    isFetching: creditorDataLoading,
    isError: creditorDataError,
  } = useSearchCreditorsByBallotIdQuery(
    {
      ballotId: editId,
    },
    { skip: !showModal || voterId ? true : false }
  );

  const [createVoteQuery, { isLoading: createVoteLoading,isError:creationError }] =
    useCreateCreditorVoteMutation();
  const [UpdateCreditorVote, { isLoading: updateVoteLoading,isError:updateError }] =
    useUpdateCreditorVoteMutation();
  const { data: voterData, isFetching: voterDataLoading,isError :voterDataError  } =
    useGetVoterDeatilsQuery(
      { CreditorVoteId: voterId },
      { skip: !voterId  }
    );
  useEffect(() => {
    if (voterId && voterData) {
      setSelectedCreditorDetail({
        creditorName: voterData?.creditorDisplayName || "",
        creditorId: voterData?.voterId || "",
        description: voterData?.creditorDescription || "",
        creditorReference: voterData?.creditorReference || "",
        relationShipToDebtor: voterData?.relationshipToDebtor || "",
      });
      setProxy(voterData?.voteProxyName || "");
      setVoteType(
        voterData?.voteResult.toString() ||  ""
      );
    }
  }, [voterData, voterId, setSelectedCreditorDetail, setProxy, setVoteType]);
  const handleCreditorSearch: any = (value: string) => {
    const selectedCreditorDetail = creditorData.find(
      (creditor: { creditorId: string }) => creditor.creditorId === value
    );
    setSelectedCreditorDetail(
      selectedCreditorDetail ? selectedCreditorDetail : {}
    );
  };

  function renderCreditorDetails(selectedCreditorDetail: {
    creditorName?: any;
    description?: any;
    creditorReference?: any;
    relationShipToDebtor?: any;
  }) {
    if (
      !selectedCreditorDetail ||
      !Object.keys(selectedCreditorDetail).length
    ) {
      return null;
    }
    const {
      creditorName,
      description,
      creditorReference,
      relationShipToDebtor,
    } = selectedCreditorDetail;
    return (
      <>
        <CreditorDetails
          creditorName={creditorName}
          creditorDescription={description}
          creditorReferenceId={creditorReference}
          relationShipToDebtor={relationShipToDebtor}
        />
      </>
    );
  }

  const resetModalValues = () => {
    setSelectedCreditorDetail({});
    setVoteType("");
    setProxy("");
  };

  const handleClose = () => {
    setShowModal(false);
    resetModalValues();
  };

  const handleVoteSubmit: any = async () => {
    setErrorMsg({ message: "", type: "" });
    if (voterId) {
      let requestBody = {
        creditorVoteId: voterData?.creditorVoteId || "",
        voteResult: voteType ? parseInt(voteType) : null,
        proxyName: proxy || "",
      };
      await UpdateCreditorVote(requestBody).then((response: any) => {
        if (response.data) {
          setShowModal(false);
          resetModalValues();
          readBallot();
          setErrorMsg({message:"Vote updated successfully", type:"success"})
        }
      });
    } else {
      const {
        caseId,
        ballotId,
        creditorId,
        creditorName,
      }: { [key: string]: string } = selectedCreditorDetail;

      const requestBody = {
        creditorId,
        ballotId: ballotId,
        caseId: caseId,
        name: creditorName,
        proxyName: proxy,
        voteResult: parseInt(voteType),
      };

      await createVoteQuery(requestBody).then((response: any) => {
        if (response.data) {
          setShowModal(false);
          resetModalValues();
          readBallot();
          setErrorMsg({message:"Vote Created successfully", type:"success"})

        }
      });
    }
  };

  return (
    <MotifModal
      onClose={handleClose}
      show={showModal}
      size="lg"
      focusTrapOptions={{
        tabbableOptions: {
          displayCheck: "none",
        },
      }}
    >
      <MotifModalHeader
        closeButtonProps={{
          "aria-label": "Custom Close Button aria-label",
          title: "Custom Close Button title",
        }}
      >
        <span>{t("pages.voting.creditorVotes.manualRecording.title")}</span>
      </MotifModalHeader>
      <MotifModalBody className="pad-t-10">
        {voterDataLoading || creditorDataLoading ? (
          <MotifProgressLoader></MotifProgressLoader>
        ) : (voterDataError || creditorDataError)?<MotifErrorMessage>{t("global.globalNotifications.wentWrong")}</MotifErrorMessage>: (
          <>
            <div className="motif-row  mar-b-10">
              <div className="motif-col-lg-6">
                <div className="formFieldLabel">
                  <MotifLabel>
                    {t(
                      "pages.voting.creditorVotes.manualRecording.creditorSearch"
                    )}{" "}
                    <span className="requiredSymbol">*</span>
                  </MotifLabel>
                </div>
                <div title={selectedCreditorDetail?.creditorName || ""}  className="">
                  <MotifFormField >
                    {voterId?<>
                    <MotifInput  disabled={true} hideClearButton={true} value={selectedCreditorDetail.creditorName}></MotifInput></>:<MotifSelect
                      onChange={handleCreditorSearch}
                      filter={true}
                      visibleOptions={3}
                      searchPlaceholder={t(
                        "global.globalPlaceholder.searchPlaceHolder"
                      )}
                      disabled={voterId ? true : false}
                      value={selectedCreditorDetail?.creditorId || ""}
                    >
                      {creditorData?.length
                        ? creditorData?.map(
                            ({ creditorName, creditorId }: any) => (
                              <MotifOption title={creditorName} key={creditorId} value={creditorId}>
                                {creditorName}
                              </MotifOption>
                            )
                          )
                        : []}
                    </MotifSelect>}
                  </MotifFormField>
                </div>
                <div className="display-flex justify-content-center ">
                  {creditorData?.length === 0 ? (
                    <MotifErrorMessage>
                      {" "}
                      {t(
                        "pages.voting.creditorVotes.manualRecording.noCreditorsExist"
                      )}
                    </MotifErrorMessage>
                  ) : (
                    " "
                  )}
                </div>
              </div>
            </div>
            <div className="motif-row mar-l-2">
              {renderCreditorDetails(selectedCreditorDetail)}
            </div>
            <div className="motif-row mar-t-20">
              <div className="motif-col-lg-6 ">
                <div className="formFieldLabel">
                  <MotifLabel>
                    {t("pages.voting.creditorVotes.manualRecording.vote")}

                    <span className="requiredSymbol">*</span>
                  </MotifLabel>
                  <MotifSelect
                    onChange={(value) => setVoteType(value)}
                    value={voteType}
                    className="vote-selection-select"
                  >
                    <MotifOption value={"0"}>
                      {t("pages.voting.creditorVotes.manualRecording.yes")}
                    </MotifOption>
                    <MotifOption value={"1"}>
                      {t("pages.voting.creditorVotes.manualRecording.no")}
                    </MotifOption>
                    <MotifOption value={"2"}>
                      {t(
                        "pages.voting.creditorVotes.manualRecording.didNotVote"
                      )}
                    </MotifOption>
                  </MotifSelect>
                </div>
              </div>

              <div className="motif-col-lg-6">
                <div className="formFieldLabel">
                  <MotifLabel>
                    {t("pages.voting.creditorVotes.manualRecording.proxy")}
                  </MotifLabel>
                  <MotifInput
                    // @ts-ignore
                    onChange={(e) => setProxy(e.target.value)}
                    value={proxy}
                    hideClearButton={true}
                  />
                </div>
              </div>
              {(creationError || updateError) && <MotifErrorMessage>{t("global.globalNotifications.wentWrong")}</MotifErrorMessage>}
            </div>
          </>
        )}
      </MotifModalBody>
      <MotifModalFooter>
        {!(voterDataLoading || creditorDataLoading || voterDataError || creditorDataError) && (
          <div
            style={{
              display: "flex",
              gap: "1rem",
            }}
          >
            <MotifButton
              onClick={handleClose}
              size="small"
              type="button"
              variant={CANCEL_BUTTON_VARIANT}
            >
              {t("global.globalActions.cancel")}
            </MotifButton>
            <MotifButton
              onClick={handleVoteSubmit}
              size="small"
              variant={SAVE_BUTTON_VARIANT}
              type={
                createVoteLoading || updateVoteLoading ? "loader" : "button"
              }
              disabled={
                Object.keys(selectedCreditorDetail).length === 0 || !voteType
              }
            >
              {t("global.globalActions.save")}
            </MotifButton>
          </div>
        )}
      </MotifModalFooter>
    </MotifModal>
  );
};
export default RecordVote;
